// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message.is-warning .message-body{border-color:#ffdd57;background:#ffdd57;color:#947600}.message.is-warning .button.is-warning{border-color:#947600;color:#947600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
